"use strict";

var _interopRequireDefault = require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.map.js");
require("core-js/modules/es.object.to-string.js");
var _interopRequireWildcard2 = _interopRequireDefault(require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/interopRequireWildcard.js"));
var _regenerator2 = _interopRequireDefault(require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/regenerator.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _lodash = _interopRequireDefault(require("lodash"));
var _log = require("@/utils/log");
var _permission = _interopRequireDefault(require("@/utils/permission"));
var _cookie = require("@/utils/cookie");
var _hike = require("@/api/hike");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// import { writeGaEvent } from '@/utils/ga'
// import { userEvent } from '@/lifehikes-init-data'
var _default = exports.default = {
  name: 'HikeAttendantReport',
  data: function data() {
    return {
      hikeId: '',
      hikeTitle: '',
      loading: false,
      downloadLoading: false,
      report: null,
      column: null
    };
  },
  created: function created() {
    var _this = this;
    return (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee() {
      var id;
      return (0, _regenerator2.default)().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            id = typeof _this.$route.params.id === 'undefined' ? '' : _this.$route.params.id;
            _this.hikeTitle = _this.$route.query.title ? _this.$route.query.title : '-';
            _this.hikeId = id;
            _this.getReport(id);
          case 1:
            return _context.a(2);
        }
      }, _callee);
    }))();
  },
  methods: {
    checkPermission: _permission.default,
    getReport: function getReport(id) {
      var _this2 = this;
      var token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      this.loading = true;
      (0, _hike.getAttendantReport)(token, id).then(function (response) {
        var resp = response.data;
        console.log('before convert', _this2.report);
        _this2.convertToTableFormat(resp.report);
        _this2.loading = false;
      }).catch(function (error) {
        (0, _log.showDebugLog)('hike-attendantReport-error', error);
        _this2.loading = false;
        (0, _log.displayPopupMessage)(error, 'error');
      });
    },
    backToHike: function backToHike() {
      var id = typeof this.$route.params.id === 'undefined' ? '' : this.$route.params.id;
      this.$router.push("/hike/index");
    },
    convertToTableFormat: function convertToTableFormat(data) {
      console.log('data', data);
      var tempColumn = [];
      var tempReportData = [];
      for (var i = 0; i < data.length; i++) {
        tempColumn.push(data[i].title);
        console.log('attendantRecordd', data[i].attendantRecords);
        for (var j = 0; j < data[i].attendantRecords.length; j++) {
          if (i == 0) {
            var record = {};
            console.log('user attendantRecordd', data[i].attendantRecords[j]);
            record['email'] = data[i].attendantRecords[j]['email'];
            record['firstName'] = data[i].attendantRecords[j]['givenName'];
            record['lastName'] = data[i].attendantRecords[j]['familyName'];
            record["stage".concat(i + 1)] = data[i].attendantRecords[j]['isCheckedIn'];
            console.log("add row");
            tempReportData.push(record);
          } else {
            console.log("amend row");
            tempReportData[j]["stage".concat(i + 1)] = data[i].attendantRecords[j].isCheckedIn;
          }
        }
      }
      this.column = tempColumn;
      this.report = tempReportData;
      console.log('after convert', this.report);
      console.log('after convert-column', this.column);
    },
    handleDownload: function handleDownload() {
      var _this3 = this;
      this.downloadLoading = true;
      Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/vendor/Export2Excel'));
      }).then(function (excel) {
        var header = [];
        header.push('Given name');
        header.push('Surname');
        header.push('Email');
        for (var i = 0; i < _this3.column.length; i++) {
          console.log('build header add');
          header.push("Stage ".concat(i + 1, " - ").concat(_this3.column[i]));
        }
        var tHeader = header;
        // const data = this.formatJson(filterVal, list)
        var xdata = _this3.buildExcelData();
        excel.export_json_to_excel({
          header: tHeader,
          data: xdata,
          filename: 'Hike Attendance Report',
          autoWidth: true,
          bookType: 'xlsx'
        });
        var header = [];
        _this3.downloadLoading = false;
      });
    },
    formatJson: function formatJson(filterVal, jsonData) {
      return jsonData.map(function (v) {
        return filterVal.map(function (j) {
          if (j === 'timestamp') {
            return parseTime(v[j]);
          } else {
            return v[j];
          }
        });
      });
    },
    buildExcelData: function buildExcelData() {
      var excelData = [];
      console.log('report row number', this.report.length);
      for (var i = 0; i < this.report.length; i++) {
        var row = [];
        row.push(this.report[i].firstName);
        row.push(this.report[i].lastName);
        row.push(this.report[i].email);
        for (var j = 0; j < this.column.length; j++) {
          row.push(this.report[i]["stage".concat(j + 1)]);
        }
        console.log("add excel row", row);
        excelData.push(row);
      }
      return excelData;
    }
  }
};